import { Button, Flex, Input, Select, Tag, Tooltip, Typography } from 'antd';
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';

import { capitalizeString } from './NftCard';
import { rarityColors } from '../const/colors';

const { Text } = Typography;

export type SortOption = 'price_asc' | 'price_desc' | 'id_asc';

interface RarityCount {
    rarity: string;
    count: number;
}

interface FilterBarProps {
    rarities: RarityCount[];
    selectedRarities: string[];
    onRaritiesChange: (rarities: string[]) => void;
    sort: SortOption;
    onSortChange: (sort: SortOption) => void;
    query: string;
    onQueryChange: (query: string) => void;
    shownCount: number;
    totalCount: number;
    onRefresh: () => void;
    loading: boolean;
}

const FilterBar = (props: FilterBarProps) => {
    const toggleRarity = (rarity: string, checked: boolean) => {
        props.onRaritiesChange(
            checked ? [...props.selectedRarities, rarity] : props.selectedRarities.filter((item) => item !== rarity)
        );
    };

    return (
        <Flex vertical gap={10} style={{ margin: '14px 0' }}>
            <Flex gap={10} wrap align='center'>
                <Input
                    allowClear
                    prefix={<SearchOutlined />}
                    placeholder='Search by ID'
                    value={props.query}
                    onChange={(event) => props.onQueryChange(event.target.value)}
                    style={{ width: 170 }}
                />
                <Select<SortOption>
                    value={props.sort}
                    onChange={props.onSortChange}
                    style={{ width: 185 }}
                    options={[
                        { value: 'price_asc', label: 'Price: Low to High' },
                        { value: 'price_desc', label: 'Price: High to Low' },
                        { value: 'id_asc', label: 'Token ID' },
                    ]}
                />
                <Tooltip title='Refresh listings'>
                    <Button icon={<ReloadOutlined />} onClick={props.onRefresh} loading={props.loading} />
                </Tooltip>
                <Text style={{ opacity: 0.7, fontSize: 13 }}>
                    {props.shownCount === props.totalCount
                        ? `${props.totalCount} items`
                        : `${props.shownCount} of ${props.totalCount} items`}
                </Text>
            </Flex>
            {props.rarities.length > 1 && (
                <Flex gap={4} wrap align='center'>
                    {props.rarities.map(({ rarity, count }) => {
                        const checked = props.selectedRarities.includes(rarity);
                        return (
                            <Tag.CheckableTag
                                key={rarity}
                                checked={checked}
                                onChange={(value) => toggleRarity(rarity, value)}
                                style={{
                                    border: `1px solid ${rarityColors[rarity] || '#595959'}`,
                                    background: checked ? rarityColors[rarity] || '#595959' : 'transparent',
                                    fontWeight: 600,
                                }}
                            >
                                {capitalizeString(rarity)} · {count}
                            </Tag.CheckableTag>
                        );
                    })}
                </Flex>
            )}
        </Flex>
    );
};

export default FilterBar;
